module.exports = __webpack_public_path__ + "img/sharp1.5aa21505.png";